<template lang="pug">

  .form-group
    .form-check
      input#addiesaasUserInputSubscribeCheckbox(v-model="form.subscribe" type="checkbox" name="subscribe")
      label(for="addiesaasUserInputSubscribeCheckbox")
        span.text-muted {{ label }}

</template>

<script>

export default {
  name: 'user-input-subscribe',

  props: {
    label: {
      type: String,
      default: 'Receive promotional emails and news',
    },
  },

  data: () => ({
    form: null,
  }),

  async created() {
    this.form = this.$parent.form;
    this.form.subscribe = this.$parent.user ? this.$parent.user.meta.subscribe : '';
  },
}

</script>
